import { useParams } from 'react-router-dom';
import { Box, lighten, useTheme } from '@mui/material';
import { DrawerHeader } from '@components/drawerItem';
import { useStore } from '@store/GlobalStore';
import { shallow } from 'zustand/shallow';
import { useQuote } from '@services/quotes';
import { PinDrawer } from '@components/drawerItem/DrawerHeader';
import { QuoteDrawerUrlParams } from '@pages/QuoteDetails/constants/drawerListItems';
import { ChatViewWrapper } from '@pages/PolicyDetails/dialogs/MessagesDialog/ChatViewWrapper';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const MessageDrawerItem = ({ isFullScreen = false }: { isFullScreen?: boolean }) => {
  const { isLioSales } = useStore((state) => state.userAuth, shallow);
  const { quoteId } = useParams<{ quoteId: string }>();
  const { quote } = useQuote(quoteId);
  const theme = useTheme();

  const isInternalQuote = quote?.hasInternalOnlyAccessRestriction ?? false;

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', minHeight: 0 }}>
      <DrawerHeader drawerTitle='Messages'>
        <PinDrawer urlParam={QuoteDrawerUrlParams.Messages} />
      </DrawerHeader>
      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
        <ChatViewWrapper
          quoteId={quoteId}
          isOpen={true}
          isSearchMode={false}
          anchorId={null}
          chatViewPropsConfig={{
            chatContainer: {
              backgroundColor: lighten(theme.palette.background.main, 0.5),
            },
            newMessage: {
              banner: isInternalQuote ? 'Users cannot message when quote is Internal Only' : undefined,
              disabled: isLioSales || isInternalQuote,
            },
          }}
        />
      </Box>
    </Box>
  );
};
